import { Vehicle } from "../../types/Vehicle";

export const VehicleOption = ({ v, loading = false }: { v: Vehicle; loading?: boolean }) => (
  <option value={v._id}>{loading ? "..." : (v.name ?? `${v.model} (${v.licensePlate})`)}</option>
);
